module.exports = __webpack_public_path__ + "static/media/Facebook.f5c0514b.svg";